/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsMultisiteWageRosterCtrl
 * @description A report of wage totals and roster cost for all companies grouped by role wage group
 */
angular.module('mercury.modules.reports.multisite')
.controller('ReportsMultisiteWageRosterCtrl', ["comparetime", "$filter", "multisite", "$q", "reporttime", "$scope", "TimeClock", "TimeRosteredShifts", "title", "userinfo", function(comparetime, $filter, multisite, $q, reporttime, $scope, TimeClock, TimeRosteredShifts, title, userinfo) {
  title.set('Roster Vs Actual');
  multisite.setMultisite(true);

  $scope.results = [];
  $scope.compare = comparetime.time() !== null;
  $scope.graphColumns = [
    {label: 'Site', type: 'string', key: 'name'},
    {label: 'Total Roster Cost', type: 'number', key: 'totalRoster', filter: 'currency'}
  ];

  var actualResults = {};
  var actualCompare = {};
  var rosterResults = {};
  var rosterCompare = {};

  var createResultLine = function(company) {
    // we don't want to add companies to the resultset multiple times, so check the restuls array and only add if it's a new companyId
    var newCompany = true;
    angular.forEach($scope.results, function(result) {
      if (result.companyId == company.id) {
        newCompany = false;
        result.show = '1';
      }
    });

    if (newCompany) {
      $scope.results.push({
        companyId: company.id,
        show: '1',
        name: company.name,
        foodRoster: null,
        foodRosterCompare: null,
        foodActual: null,
        foodActualCompare: null,
        beverageRoster: null,
        beverageRosterCompare: null,
        beverageActual: null,
        beverageActualCompare: null,
        totalRoster: null,
        totalRosterCompare: null,
        totalActual: null,
        totalActualCompare: null
      });
    }
  };

  var buildReport = function() {
    angular.forEach(userinfo.companies(), function(company) {
      if (multisite.isCompanyDisabled(company.id) || !userinfo.companyHasPermission('Time', company.id)) {
        angular.forEach($scope.results, function(result) {
          if (result.companyId == company.id) {
            result.show = '0';
          }
        });
        $scope.$emit('dataTableUpdate');
        return;
      }

      var hasPayrollPermission = userinfo.companyHasPermission('Payroll', company.id);

      // fetch data for any sites that were deselected when we first fetched the results
      if (!actualResults[company.id]) {
        actualResults[company.id] = TimeClock.getSummaryByRole(reporttime.start(), reporttime.end(), company.id);
      }
      if (!rosterResults[company.id]) {
        rosterResults[company.id] = TimeRosteredShifts.getSummary(reporttime.start(), reporttime.end(), company.id);
      }

      if ($scope.compare) {
        if (!actualResults[company.id]) {
          actualCompare[company.id] = TimeClock.getSummaryByRole(comparetime.start(), comparetime.end(), company.id);
        }
        if (!rosterResults[company.id]) {
          rosterCompare[company.id] = TimeRosteredShifts.getSummary(comparetime.start(), comparetime.end(), company.id);
        }
      }

      actualResults[company.id].then(function(actualResult) {
        angular.forEach($scope.results, function(resultLine) {
          if (resultLine.companyId == company.id) {
            if (hasPayrollPermission) {
              resultLine.foodActual = $filter('sumof')($filter('filter')(actualResult, {roleCostGroup: 'f'}), 'cost');
              resultLine.beverageActual = $filter('sumof')($filter('filter')(actualResult, {roleCostGroup: 'b'}), 'cost');
              resultLine.totalActual = $filter('sumof')(actualResult, 'cost');
            } else {
              resultLine.foodActual = 0;
              resultLine.beverageActual = 0;
              resultLine.totalActual = 0;
            }
          }
        });
        $scope.$emit('update.googleChart');
      });

      if (actualCompare[company.id]) {
        actualCompare[company.id].then(function(compareResult) {
          angular.forEach($scope.results, function(resultLine) {
            if (resultLine.companyId == company.id) {
              if (hasPayrollPermission) {
                resultLine.foodActualCompare = $filter('sumof')($filter('filter')(compareResult, {roleCostGroup: 'f'}), 'cost');
                resultLine.beverageActualCompare = $filter('sumof')($filter('filter')(compareResult, {roleCostGroup: 'b'}), 'cost');
                resultLine.totalActualCompare = $filter('sumof')(compareResult, 'cost');
              } else {
                resultLine.foodActualCompare = 0;
                resultLine.beverageActualCompare = 0;
                resultLine.totalActualCompare = 0;
              }
            }
          });
          $scope.$emit('update.googleChart');
        });
      }

      rosterResults[company.id].then(function(rosterResult) {
        angular.forEach($scope.results, function(resultLine) {
          if (resultLine.companyId == company.id) {
            if (hasPayrollPermission) {
              resultLine.foodRoster = $filter('sumof')($filter('filter')(rosterResult, {roleCostGroup: 'f'}), 'cost');
              resultLine.beverageRoster = $filter('sumof')($filter('filter')(rosterResult, {roleCostGroup: 'b'}), 'cost');
              resultLine.totalRoster = $filter('sumof')(rosterResult, 'cost');
            } else {
              resultLine.foodRoster = 0;
              resultLine.beverageRoster = 0;
              resultLine.totalRoster = 0;
            }
          }
        });
        $scope.$emit('update.googleChart');
      });

      if (rosterCompare[company.id]) {
        rosterCompare[company.id].then(function(rosterResult) {
          angular.forEach($scope.results, function(resultLine) {
            if (resultLine.companyId == company.id) {
              if (hasPayrollPermission) {
                resultLine.foodRosterCompare = $filter('sumof')($filter('filter')(rosterResult, {roleCostGroup: 'f'}), 'cost');
                resultLine.beverageRosterCompare = $filter('sumof')($filter('filter')(rosterResult, {roleCostGroup: 'b'}), 'cost');
                resultLine.totalRosterCompare = $filter('sumof')(rosterResult, 'cost');
              } else {
                resultLine.foodRosterCompare = 0;
                resultLine.beverageRosterCompare = 0;
                resultLine.totalRosterCompare = 0;
              }
            }
          });
          $scope.$emit('update.googleChart');
        });
      }

      createResultLine(company);
    });

    $scope.$emit('dataTableUpdate');
  };

  angular.forEach(userinfo.companies(), function(company) {
    if (multisite.isCompanyDisabled(company.id)) {
      angular.forEach($scope.results, function(result) {
        if (result.companyId == company.id) {
          result.show = '0';
          $scope.$emit('dataTableUpdate');
        }
      });
      return;
    }

    //Also check that the user has Time permission for this company - skip the company if not
    if (!userinfo.companyHasPermission('Time', company.id)) {
      return;
    }

    createResultLine(company);

    actualResults[company.id] = TimeClock.getSummaryByRole(reporttime.start(), reporttime.end(), company.id);
    rosterResults[company.id] = TimeRosteredShifts.getSummary(reporttime.start(), reporttime.end(), company.id);

    if ($scope.compare) {
      actualCompare[company.id] = TimeClock.getSummaryByRole(comparetime.start(), comparetime.end(), company.id);
      rosterCompare[company.id] = TimeRosteredShifts.getSummary(comparetime.start(), comparetime.end(), company.id);
    }

    $scope.$emit('dataTableUpdate');
  });

  $scope.loading = $q.race(actualResults);
  $scope.loading.then(buildReport);
  $scope.$on('userInfoUpdated', buildReport);
}]);
